<template>
  <div class="domain-list">
    <div
      class="item clearfix"
      :class="{ 'is-hover-buy': layout.indexOf('button') === -1 }"
      v-for="(item, i) in domainList"
      :key="item.businessId"
    >
      <div class="fl">
        <span class="domain" v-if="isShowLayout('domain')"
          >{{ item.domainName }}{{ item.domainSuffix }}</span
        >
        <tag
          :status="asyncStatus[item.businessId]"
          v-if="isShowLayout('tag')"
        ></tag>
      </div>
      <span
        class="cart-buttons"
        v-if="checkHZname(item.domainName,item.domainSuffix)"
      >
        <span class="red">根据cnnic命名规则，国字头禁止注册</span>
      </span>

      <template v-else>
        <span v-if="asyncStatus[item.businessId] === 2">
          <del v-if="isShowLayout('price')">{{ item.basePrice }}</del>
          <span class="price" v-if="isShowLayout('price')">
            <em>{{ item.payPrice }}</em> 元/年
          </span>
          <a
            class="f12 g6 more-price ml5 mr5"
            href="javascript:; "
            v-if="isShowLayout('morePrice')"
            @mouseenter="getDomainGoodsPriceList(item, i)"
          >
            更多价格
            <span class="arrow"></span>
            <div class="more-price-list">
              <!-- {{item.morePrice}} -->
              <table v-loading="!morePrice[item.businessId]">
                <tr>
                  <th></th>
                  <th>一年</th>
                  <th>三年</th>
                  <th>五年</th>
                  <th>十年</th>
                </tr>
                <tr>
                  <td>新注</td>
                  <td v-for="(price, i) in morePrice[item.businessId]" :key="i">
                    {{ price.newGoodsSheetModel.payPrice }}元
                  </td>
                </tr>
                <tr>
                  <td>续费</td>
                  <td v-for="(price, i) in morePrice[item.businessId]" :key="i">
                    {{
                      price.renewGoodsSheetModel &&
                      price.renewGoodsSheetModel.payPrice
                    }}元
                  </td>
                </tr>
              </table>
            </div>
          </a>

          <span
            class="cart-buttons"
            v-if="!isDisable(item) && item.domainSuffix == '.商标'"
          >
            <button
              class="addCart direct"
              style="border-radius: 0"
              @click="directBuy(item)"
            >
              直接购买
            </button>
          </span>

          <span class="cart-buttons" v-else>
            <button class="addCartDisabled" v-if="isDisable(item)">
              已添加
            </button>

            <a href="https://tb.53kf.com/code/client/10168926/3" class="kf53zx bt" target="_blank">在线咨询</a>
            <button
              class="labour"
              @click="setFormEvent"
              v-if="!isDisable(item) && item.buyStatus === 0"
            >
              联系商务代表
            </button>
          </span>
        </span>
        <span v-if="asyncStatus[item.businessId] === 1">
          <a
            :href="`/domain/info?domain=${item.domainName.toLowerCase()}${item.domainSuffix}`"
            target="_blank "
            class="view-whois"
            >查看域名信息 ></a
          >
        </span>
        <span v-if="asyncStatus[item.businessId] === 0">
          <el-button
            type="text"
            v-if="isShowLayout('tag')"
            :loading="item.isLoading"
            @click="retry(item)"
            >重试</el-button
          >
        </span>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    tag: {
      render: function (createElement) {
        const config = (function (status) {
          switch (status) {
            case 0:
              return {
                class: "error",
                text: "查询失败"
              };
            case 1:
              return {
                class: "registered",
                text: "已注册"
              };
            case 2:
              return {
                class: "unregistered",
                text: "未注册"
              };
          }
        })(this.status);

        if (!config) {
          return createElement("img", {
            class: "loading-tag",
            attrs: { src: require("../../static/assets/loading.gif") }
          });
        }

        return createElement(
          "span",
          {
            class: `${config.class}-tag`
          },
          config.text
        );
      },
      props: ["status"]
    }
  },
  data() {
    return {
      cartQueue: [],
      asyncStatus: {},
      morePrice: {}
    };
  },
  props: ["layout", "data", "cartList", "userStatus"],
  computed: {
    domainList() {
      return Array.isArray(this.data)
        ? this.data.map(v => {
          const businessId = v.goodsSheetModel.businessId;

          const isAsync = "buyStatus" in v;
          const domain = businessId.split(".");
          const domainName = domain.shift();
          const domainSuffix = "." + domain.join(".");
          const buyStatus = isAsync
            ? v.buyStatus
            : v.domainInfoReturnVo.buyStatus;

          const obj = {
            businessId: businessId,
            // status: 0 || this.asyncStatus[businessId],
            buyStatus,
            domainName: domainName.toLowerCase(),
            domainSuffix,
            payPrice: v.goodsSheetModel.payPrice,
            basePrice: v.goodsSheetModel.basePrice
          };

          if (!(businessId in this.asyncStatus)) {
            this.$set(this.asyncStatus, businessId, "");
            if (isAsync) {
              this.queryStatus(obj);
            } else {
              this.asyncStatus[businessId] = v.domainInfoReturnVo.status;
            }
          }

          return obj;
        })
        : [];
    }
  },
  methods: {
    isShowLayout(name) {
      return this.layout.indexOf(name) !== -1;
    },
    checkHZname(text,name) {
      var reg = /china/i;
      if (reg.test(text) || text.indexOf('中国') > -1) {
      } else {
        return false;
      }
      var arr = ['.cn','.中国','.com.cn','.net.cn','.org.cn','.gov.cn','.ac.cn','.bj.cn','.sh.cn','.tj.cn','.cq.cn','.he.cn','.sx.cn','.nm.cn','.ln.cn','.jl.cn','.hl.cn','.js.cn','.zj.cn','.ah.cn','.fj.cn','.jx.cn','.sd.cn','.ha.cn','.hb.cn','.hn.cn','.gd.cn','.gx.cn','.hi.cn','.sc.cn','.gz.cn','.yn.cn','.xz.cn','.sn.cn','.gs.cn','.qh.cn','.nx.cn','.xj.cn','.tw.cn'];
      for(var i = 0; i < arr.length; i++) {
        if(arr[i] == name) {
          return true;
        }
      }
      return false;
    },
    setFormEvent() {
      window.setFormEvent && window.setFormEvent();
    },
    queryStatus(item) {
      $.get(
        encodeURI(`/domain/findDomainStatus?domainName=${item.domainName.toLowerCase()}&domainSuffix=${item.domainSuffix}`)
      ).then(
        response => {
          this.asyncStatus[item.businessId] = response.domainStatus;
        },
        err => {
          this.asyncStatus[item.businessId] = 0;
        }
      );
    },
    retry(item) {
      this.asyncStatus[item.businessId] = "";
      this.queryStatus(item);
    },
    isDisable(item) {
      if (!this.cartList) return false;
      for (let i = 0; i < this.cartList.length; i++) {
        if (
          this.cartList[i].domainName === item.domainName &&
          this.cartList[i].domainSuffix === item.domainSuffix
        ) {
          return true;
        }
      }
    },
    directBuy(item) {
      this.$router.push({
        path: "/domain/register",
        query: {
          item: JSON.stringify({
            domainName: item.domainName.toLowerCase(),
            domainSuffix: item.domainSuffix
          })
        }
      });
    },
    addCart(item) {
      if (this.cartQueue.indexOf(item.businessId) === -1) {
        this.cartQueue.push(item.businessId);
      }
      const domain = {
        id: "",
        domainName: item.domainName.toLowerCase(),
        domainSuffix: item.domainSuffix
      };

      if (this.userStatus === "offline") {
        this.addCartLocal(domain);
        return;
      }

      $.ajax({
        url: `/dcarts/savedomaincarts`,
        method: "POST",
        data: { data: JSON.stringify([domain]) },
        success: data => {
          if (this.$parent.getUserStatus(data) === "offline") {
            this.addCartLocal(domain);
            return;
          }

          if (this.$parent.getUserStatus(data) === "unknown") {
            this.delCartQueue(domain);
            this.$parent.throwError("加入购物车失败");
            return;
          }

          if (data && data.cartGroupList && data.cartGroupList.length) {
            domain.id = data.cartGroupList[0].id;
            this.addCartLocal(domain);
          }
        },
        error: err => {
          this.delCartQueue(domain);
          this.$parent.throwError("加入购物车失败");
          return;
        }
      });
    },
    delCartQueue(domain) {
      const index = this.cartQueue.indexOf(
        domain.domainName.toLowerCase() + domain.domainSuffix
      );
      if (index !== -1) {
        this.cartQueue.splice(index, 1);
      }
    },
    addCartLocal(domain) {
      this.delCartQueue(domain);
      this.$emit("addCart", domain);
    },
    getDomainGoodsPriceList(item, i) {
      if (this.morePrice[item.businessId]) {
        return;
      }
      $.get(
        encodeURI(`/domain/getDomainGoodsPriceList?domainName=${item.domainName.toLowerCase()}&domainSuffix=${item.domainSuffix}`)
      ).then(response => {
        this.$set(this.morePrice, item.businessId, response.goodsPriceMapList);
      });
    }
  },
  created() { }
};
</script>



// WEBPACK FOOTER //
// src/components/domian-result-list.vue